import { render, staticRenderFns } from "./building-courtesy-dialog.vue?vue&type=template&id=0c06de6e&scoped=true"
import script from "./building-courtesy-dialog.vue?vue&type=script&lang=js"
export * from "./building-courtesy-dialog.vue?vue&type=script&lang=js"
import style0 from "./building-courtesy-dialog.vue?vue&type=style&index=0&id=0c06de6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c06de6e",
  null
  
)

export default component.exports